export const forecastPaginatedTableMetricConfig = [
  {
    key: 'realSales',
    label: 'Real Sales',
    optional: true,
    color: 'var(--chart-real-sales)',
  },
  {
    key: 'b2bSales',
    label: 'B2B Sales',
    optional: true,
    color: 'var(--chart-b2b-sales)',
  },
  {
    key: 'stock',
    label: 'Stock',
    optional: true,
    color: 'var(--chart-stock)',
  },
  {
    key: 'realSalesAverage',
    label: 'Real Sales Average',
    optional: true,
    color: 'var(--chart-real-sales-average)',
  },
  {
    key: 'forecastProposal',
    label: 'Forecast Proposal',
    optional: true,
    color: 'var(--chart-forecast-proposal)',
  },
  {
    key: 'modelProposal',
    label: 'Model Proposal',
    optional: true,
    color: 'var(--chart-model-proposal)',
  },
  {
    key: 'modelProposal2',
    label: 'Model Proposal 2',
    optional: true,
    color: 'var(--chart-model-proposal-2)',
  },
  {
    key: 'validatedForecast',
    label: 'Validated Forecast',
    optional: false,
    color: 'var(--chart-validated-forecast)',
  },
  {
    key: 'productPriceIndex',
    label: 'Product Price Index',
    optional: true,
    color: 'var(--chart-product-price)',
  },
];
